import { useState } from "react";
import { MessageCircle } from "lucide-react";
import EnquiryDialog from "./EnquiryDialog";
import { motion } from "framer-motion";

const FloatingEnquiry = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <motion.button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-8 right-8 bg-primary-main text-white p-4 rounded-full shadow-lg hover:bg-primary-light transition-colors z-40"
        data-testid="floating-enquiry-button"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        animate={{
          boxShadow: [
            "0 4px 14px rgba(0, 51, 102, 0.4)",
            "0 6px 20px rgba(0, 51, 102, 0.6)",
            "0 4px 14px rgba(0, 51, 102, 0.4)",
          ],
        }}
        transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut",
          },
        }}
        aria-label="Open enquiry form"
      >
        <MessageCircle size={24} />
      </motion.button>

      <EnquiryDialog isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FloatingEnquiry;
